import { isIE } from './helpers';

async function getCurrentPosition() {
    const notAvailError = 'Location not available for device.';
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation || !navigator.geolocation.getCurrentPosition) {
            const err = new Error(notAvailError);
            err.code = -1;
            reject(err);
        }
        navigator.geolocation.getCurrentPosition(
            ({ coords }) => { resolve({ coords }); },
            error => {
                reject(error);
            }
        );
    });
}

/**
 * A wrapper for the navigator geolocation that can be used by
 * models needing user location.
 */
export default class GeolocationService {
    constructor() {
        this.status = 'prompt';
        this.error = null;
    }

    async init() {
        if (navigator.geolocation && navigator.permissions && navigator.permissions.query) {
            const geoPermission = await navigator.permissions.query({ name: 'geolocation' });
            if (geoPermission) {
                this.status = geoPermission.state;
                geoPermission.onchange = () => {
                    this.status = geoPermission.state;
                };
                return;
            }
        }
        try {
            await this.getCurrentPosition();
        } catch (e) {
            // Silently fail here, nothing else to do.
        }
    }

    async getCurrentPosition() {
        this.error = null;
        if (this.currentPosition) {
            return this.currentPosition;
        }
        try {
            this.currentPosition = await getCurrentPosition();
            this.status = 'granted';
        } catch (err) {
            console.warn('Error getting position', err);
            if (err.code === 1 || err.code === err.PERMISSION_DENIED) {
                if (isIE()) {
                    // IE Will say denied, event if user allowed but there are other settings that deny
                    this.status = 'denied';
                    this.error = 'Unable to get device location.';
                } else {
                    this.status = 'denied';
                }
            } else if (err.code === -1 || err.code === err.POSITION_UNAVAILABLE) {
                this.status = 'unavailable';
                this.error = err.message;
            }
            throw err;
        }
        return this.currentPosition;
    }
}
